import styled from 'styled-components';
import { colors } from '../../../stylesheets';

const TabHeaderWrapper = styled.div`
  border: 1px solid ${(props) => colors[props.borderColor]};
  border-radius: 24px;
`;

export default TabHeaderWrapper;
